import { fullLine, prematchLine } from '@/config/constants';

export const prepareShareBetData = (data: ShareBetData[]) =>
  data.reduce((acc, { eventId = '', outcomes = [], type = 'bet' }) => {
    fullLine.forEach((line) => {
      const preparedData: PreparedShareBetData = {
        eventId: `${line}.${eventId}`,
      };

      if (type === 'betbuilder' && prematchLine.includes(line)) {
        const betBuilderData = preparedData;
        betBuilderData.betBuilderOutcomes = outcomes.map(({ outcomeId = '', marketId = '' }) => ({
          outcomeId,
          pidLid: `${line}.${eventId}.${marketId}`,
        }));
        betBuilderData.isBetBuilder = true;
        acc.push(preparedData);
      }

      if (type === 'bet') {
        const { marketId = '', outcomeId = '' } = outcomes[0] || {};
        const simpleData = preparedData;
        simpleData.outcomeId = outcomeId;
        simpleData.marketId = `${line}.${eventId}.${marketId}`;
        acc.push(preparedData);
      }
    });
    return acc;
  }, [] as PreparedShareBetData[]);

interface ShareBetData {
  eventId: string;
  outcomes: Array<{
    marketId: string;
    outcomeId: string;
  }>;
  type: 'betbuilder' | 'bet';
}

interface PreparedShareBetData {
  eventId: string;
  betBuilderOutcomes?: Array<{
    outcomeId: string;
    pidLid: string;
  }>;
  isBetBuilder?: boolean;
  outcomeId?: string;
  marketId?: string;
}
